var _Rect, _Rect2, _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
function SvgCircledArrowRight(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#1A1D43"
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#fff",
    fill: "transparent"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#circled-arrow-right_svg__clip0_13537_579)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M9 14a.31.31 0 01.312-.306h9.375A.31.31 0 0119 14a.31.31 0 01-.313.306H9.312A.31.31 0 019 14z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M14.091 9.506c.122-.12.32-.12.442 0l4.375 4.278a.3.3 0 010 .432l-4.375 4.278a.317.317 0 01-.442 0 .3.3 0 010-.432L18.245 14l-4.154-4.062a.3.3 0 010-.432z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "circled-arrow-right_svg__clip0_13537_579"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h10v10H0z"
  })))));
}
export default SvgCircledArrowRight;